import * as React from "react";
import type { SVGProps } from "react";
const SvgNote01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M18.569 4.421 13.516 2.4v15.159a4.042 4.042 0 1 1-2.021-3.502c.337.157 1.69 1.242 2.02 1.986"
    />
  </svg>
);
export default SvgNote01;
